import { AxiosHttpService } from "./AxiosHttpService";
import { LoginRepository } from "repository/login/LoginRepo";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

export class LoginService {

    private httpService: IHttpService

    private _login: LoginRepository

    constructor(url?: string) {
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/login`;
        const apiClient = axios.create({
            baseURL: baseURL,
            timeout: 1000 * 60,
        })
        this.httpService = new AxiosHttpService(apiClient);
        this._login = new LoginRepository(this.httpService);
    }

    private getPermissionsIdListFromHex = (permissionsHex: string): number[] => {
        const numero = BigInt(`0x${permissionsHex}`)
        const binary = numero.toString(2)
        const permissions = [...binary]
            .map((bit, i) => (bit === '1' ? i + 1 : null))
            .filter((id): id is number => id !== null);
        return permissions;
    }

    private getPermissionsListFromId = (
        permissionsIds: number[],
        permissionsNameList: Permiso[]
    ) => {
        const permissions = permissionsIds.map(
            id => permissionsNameList.find(
                p => p.permission_id === id)
            ?.name).filter(name => name !== undefined)
        return permissions;
}


    public async login(email: string, password: string, opt?: string): Promise<LoginResponse> {
        const response = await this._login.login(email, password, opt);

        const token = jwtDecode<{ permissions_hex: string }>(response.access_token)

        const permissionsIds = this.getPermissionsIdListFromHex(
            token.permissions_hex
        )
        const all_permissions: Permiso[]  = JSON.parse(localStorage.getItem('all_permissions') || '[]')
       const permissions = this.getPermissionsListFromId(
            permissionsIds,
            all_permissions
        )

        return {...response, permissions: permissions};
    }
}



